// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/primeicons/primeicons.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
}

html,
body {
  margin: 0;
  background-color: #f2efea;
}

body {
  transition: padding-top 240ms cubic-bezier(0.22, 1, 0.36, 1);
}

body.accountSettingsBg {
  background: linear-gradient(
    180deg,
    rgba(242, 239, 234, 0.960784) 25.48%,
    rgba(255, 255, 255, 0.960784) 100%
  );
  background-attachment: fixed;
}

@media screen and (max-width: 768px) {
  body.accountSettingsBg {
    background: rgba(239, 237, 234, 1);
    background-attachment: initial;
  }
}

body.offline-banner-visible {
  padding-top: 28px;
}

a {
  text-decoration: none;
  color: inherit;
}

.stationInfo a {
  color: #0b66ff;
  text-decoration: underline;
  text-decoration-thickness: 1.2px;
  border-bottom: 1px solid rgba(11,102,255,0.12);
  transition: color .12s ease, transform .12s ease;
  word-break: break-word;
}

.stationInfo a:hover,
.stationInfo a:focus {
  color: #084ec1;
  text-decoration: none;
  outline: none;
}

.stationInfo a:focus-visible {
  box-shadow: 0 0 0 3px rgba(11,102,255,0.18);
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;;EAEE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE;;;;GAIC;EACD,4BAA4B;AAC9B;;AAEA;EACE;IACE,kCAAkC;IAClC,8BAA8B;EAChC;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;EAChC,8CAA8C;EAC9C,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB","sourcesContent":["@import \"primeicons/primeicons.css\";\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  font-family: Roboto, sans-serif;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  background-color: #f2efea;\r\n}\r\n\r\nbody {\r\n  transition: padding-top 240ms cubic-bezier(0.22, 1, 0.36, 1);\r\n}\r\n\r\nbody.accountSettingsBg {\r\n  background: linear-gradient(\r\n    180deg,\r\n    rgba(242, 239, 234, 0.960784) 25.48%,\r\n    rgba(255, 255, 255, 0.960784) 100%\r\n  );\r\n  background-attachment: fixed;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  body.accountSettingsBg {\r\n    background: rgba(239, 237, 234, 1);\r\n    background-attachment: initial;\r\n  }\r\n}\r\n\r\nbody.offline-banner-visible {\r\n  padding-top: 28px;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.stationInfo a {\r\n  color: #0b66ff;\r\n  text-decoration: underline;\r\n  text-decoration-thickness: 1.2px;\r\n  border-bottom: 1px solid rgba(11,102,255,0.12);\r\n  transition: color .12s ease, transform .12s ease;\r\n  word-break: break-word;\r\n}\r\n\r\n.stationInfo a:hover,\r\n.stationInfo a:focus {\r\n  color: #084ec1;\r\n  text-decoration: none;\r\n  outline: none;\r\n}\r\n\r\n.stationInfo a:focus-visible {\r\n  box-shadow: 0 0 0 3px rgba(11,102,255,0.18);\r\n  border-radius: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
